"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _addjs = _interopRequireDefault(require("./utils/addjs"));

var _clipper_props = require("./clipper_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Clipper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Clipper, _PureComponent);

  function Clipper(props) {
    var _this;

    _classCallCheck(this, Clipper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Clipper).call(this, props)); // 加载完js之后初始化裁剪模块

    _this.haveClipperJS = false;
    (0, _addjs["default"])(function () {
      _this.haveClipperJS = true;

      _this.init();
    });

    _this.nullList();

    return _this;
  }

  _createClass(Clipper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.initChange || !this.isInitTriggerChange) {
        this.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.timeout = null;
      this.domRef = null;
      this.clipper = null;
      this.isInitTriggerChange = false;
    } // 初始化实例

  }, {
    key: "genClipperInstance",
    value: function genClipperInstance() {
      if (!this.clipper && this.haveClipperJS && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.SPAClipper) {
        this.clipper = new window.SPAClipper.Clipper(this.domRef, this.props);
      }
    } // 设置图片

  }, {
    key: "setImage",
    value: function setImage() {
      var _this$props = this.props,
          data = _this$props.data,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url,
          clipWidth = _this$props.clipWidth,
          clipHeight = _this$props.clipHeight,
          notScale = _this$props.notScale,
          limitMinScale = _this$props.limitMinScale,
          setImagePosition = _this$props.setImagePosition,
          minScale = _this$props.minScale,
          maxScale = _this$props.maxScale,
          perScalePixel = _this$props.perScalePixel,
          maxScaleTimes = _this$props.maxScaleTimes,
          initChange = _this$props.initChange;
      var clipperData = {};

      if (this.clipper && this.clipper.isRender) {
        if (url) {
          clipperData.url = url;
        }

        if (typeof clipWidth !== 'undefined') {
          clipperData.clipWidth = clipWidth;
        }

        if (typeof clipHeight !== 'undefined') {
          clipperData.clipHeight = clipHeight;
        }

        if (typeof notScale !== 'undefined') {
          clipperData.notScale = notScale;
        }

        if (typeof limitMinScale !== 'undefined') {
          clipperData.limitMinScale = limitMinScale;
        }

        if (typeof setImagePosition !== 'undefined') {
          clipperData.setImagePosition = setImagePosition;
        }

        if (typeof minScale !== 'undefined') {
          clipperData.minScale = minScale;
        }

        if (typeof maxScale !== 'undefined') {
          clipperData.maxScale = maxScale;
        }

        if (typeof perScalePixel !== 'undefined') {
          clipperData.perScalePixel = perScalePixel;
        }

        if (typeof maxScaleTimes !== 'undefined') {
          clipperData.maxScaleTimes = maxScaleTimes;
        }

        this.clipper.setImage(_objectSpread({}, data, {}, clipperData, {
          triggerChange: initChange
        }));
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var _this2 = this;

      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          onPreviewData = _this$props2.onPreviewData,
          previewWidth = _this$props2.previewWidth;

      if (this.clipper && this.clipper.isRender && !this.isInitTriggerChange) {
        this.clipper.on('change', function (event, data) {
          var previewData = {};

          if ((0, _spauiUtils.isFunction)(onChange)) {
            onChange(event, data);
          }

          if (previewWidth > 0 && (0, _spauiUtils.isFunction)(onPreviewData)) {
            previewData = _this2.clipper.getPreviewData(previewWidth);
            onPreviewData(event, previewData);
          }
        });
        this.isInitTriggerChange = true;
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      clearTimeout(this.timeout); // 声明后初始化下返回数据

      if (!this.clipper) {
        this.timeout = setTimeout(function () {
          _this3.genClipperInstance();

          _this3.onChange();

          _this3.setImage();
        }, 10);
      } else {
        this.setImage();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {}, Clipper), {
        ref: function ref(el) {
          _this4.domRef = el;
        }
      }));
    }
  }]);

  return Clipper;
}(_react.PureComponent); // 组件标记


_defineProperty(Clipper, "propTypes", _clipper_props.propTypes);

_defineProperty(Clipper, "defaultProps", _clipper_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Clipper, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Clipper;
exports["default"] = _default;